import {gsap} from "../LibrariesImport";

export default class Share {
    static init() {
        const shareButtons = document.querySelectorAll(".share-container .share");
        shareButtons.forEach(shareButton => {
            this.buildShareButton(shareButton);
        });
    }

    static buildShareButton(shareButton) {
        const shareText = shareButton.querySelector(".share-text");
        const copyText = shareButton.querySelector(".copy-text");
        if (navigator.share) {
            copyText.remove();
            shareButton.addEventListener("click", () => {
                navigator.share({
                    title: document.title,
                    url: window.location.href
                }).then(() => {
                })
                    .catch(console.error);
            });
        } else {
            shareText.remove();
            shareButton.classList.remove("share");
            shareButton.classList.add("copy");
            const success = shareButton.querySelector(".success");
            const error = shareButton.querySelector(".error");
            shareButton.addEventListener("click", () => {
                if (navigator.clipboard) {
                    navigator.clipboard.writeText(window.location.href)
                        .then(() => {
                            gsap.to(success, {
                                opacity: 1,
                                duration: 0.3,
                                onComplete: () => {
                                    gsap.to(success, {
                                        opacity: 0,
                                        delay: 1
                                    });
                                }
                            });
                        })
                        .catch(() => {
                            gsap.to(error, {
                                opacity: 1,
                                duration: 0.3,
                                onComplete: () => {
                                    gsap.to(error, {
                                        opacity: 0,
                                        delay: 1
                                    });
                                }
                            });
                        });
                } else {
                    gsap.to(error, {
                        opacity: 1,
                        duration: 0.3,
                        onComplete: () => {
                            gsap.to(error, {
                                opacity: 0,
                                delay: 1
                            });
                        }
                    });
                }
            });
        }
    }
}